import CheckboxView from "../view/checkbox.js";
import CheckboxModel from "../model/checkbox.js";

import {
  defaultCheckboxModelData,
  ActionType
} from "../../const.js";
export default class Checkbox {
  constructor(element, animation) {
    this._element = element;
    this._animation = animation;

    this._view = null;
    this._model = null;

    this._handleChangeModel = this._handleChangeModel.bind(this);
  }

  init() {
    this._view = new CheckboxView(this._element);
    this._model = new CheckboxModel(Object.assign(
        {},
        defaultCheckboxModelData
    ));
    this._model.addObserver(this._handleChangeModel);
  }

  getName() {
    return this._view.getName();
  }

  getValue() {
    return this._view.getValue();
  }

  checkIfChecked() {
    return this._view.isChecked();
  }

  getHeight() {
    let height = 0;

    if (!this._model.getData().hidden) {
      const styles = window.getComputedStyle(this._element);
      height = this._element.offsetHeight;

      [`margin-top`, `margin-bottom`].forEach((property) => {
        if (styles[property] !== undefined) {
          height += +styles[property].replace(/[^\d]/g, ``);
        }
      });
    }

    return height;
  }

  hide() {
    const modelData = this._model.getData();
    this._model.changeData(
        Object.assign(
            {},
            modelData,
            {
              hidden: true
            }
        ),
        ActionType.HIDE
    );
  }

  show() {
    const modelData = this._model.getData();
    this._model.changeData(
        Object.assign(
            {},
            modelData,
            {
              hidden: false
            }
        ),
        ActionType.SHOW
    );
  }

  check() {
    this._view.check();
  }

  reset() {
    this._view.reset();
  }

  updateEnabledValues(enabledData) {
    const name = this.getName();
    const value = this.getValue();

    if (!enabledData[name]) {
      return;
    }

    const isEnabled = enabledData[name][`data`]
      .some((item) => item === value);

    if (isEnabled === true) {
      this._view.enable();
    } else {
      this._view.disable();
    }
  }

  _handleChangeModel(action) {
    switch (action) {
      case ActionType.SHOW:
        this._view.show();
        break;
      case ActionType.HIDE:
        this._view.hide();
        break;
    }
  }
}
